import type { IconData } from '@stacksjs/iconify-core'

export const cameraControl: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M336 256a80 80 0 1 0-80 80a80.09 80.09 0 0 0 80-80m-128 0a48 48 0 1 1 48 48a48.055 48.055 0 0 1-48-48m-48 141.988L245.307 496h21.386L352 397.988V368H160ZM307.825 400L256 459.544L204.175 400ZM245.307 16L160 114.012V144h192v-29.988L266.693 16Zm-41.132 96L256 52.456L307.825 112ZM16 245.307v21.386L114.013 352H144V160h-29.987Zm96 62.519L52.455 256L112 204.174ZM397.987 160H368v192h29.987L496 266.693v-21.386ZM400 307.826V204.174L459.545 256Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cameraControl
